import { render } from "./SelfHelp.vue?vue&type=template&id=a4538a92&scoped=true"
import script from "./SelfHelp.vue?vue&type=script&lang=js"
export * from "./SelfHelp.vue?vue&type=script&lang=js"

import "./SelfHelp.vue?vue&type=style&index=0&id=a4538a92&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4538a92"]])

export default __exports__